const imgExtensionsList = [
    'jpg', 'jpeg', 'png', 'gif', 'webp'
  ]

export default imgExtensionsList